import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './pages/admin/styles/admin.css';
import './App.css';

// Components
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';

// Public Pages
import Home from './pages/Home';
import About from './pages/About';
import Departments from './pages/Departments';
import Courses from './pages/Courses';
import Faculty from './pages/Faculty';
import Events from './pages/Events';
import Gallery from './pages/Gallery';
import Contact from './pages/Contact';

// Admin Pages
import AdminLogin from './pages/admin/Login';
import AdminDashboard from './pages/admin/Dashboard';
import AcademicYears from './pages/admin/AcademicYears';
import DepartmentsAdm from './pages/admin/Departments';
import AdminAbout from './pages/admin/About_college';

// Check if user is authenticated
const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('admin_token');
  return token ? children : <Navigate to="/admin/login" />;
};

// Layout component for public pages
const PublicLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* ========== ADMIN ROUTES (No Navbar/Footer) ========== */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/departments" element={<DepartmentsAdm />} />
          <Route path="/admin/about_college" element={<AdminAbout />} />
          {/* Protected Admin Routes */}
          <Route path="/admin/dashboard" element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          } />
          
          {/* Add more admin routes here when you create the pages */}
          <Route path="/admin/academic-years" element={<AcademicYears />} />
          {/* ========== PUBLIC ROUTES (With Navbar/Footer) ========== */}
          <Route path="/" element={
            <PublicLayout>
              <Home />
            </PublicLayout>
          } />
          
          <Route path="/about" element={
            <PublicLayout>
              <About />
            </PublicLayout>
          } />
          
          <Route path="/departments" element={
            <PublicLayout>
              <Departments />
            </PublicLayout>
          } />
          
          <Route path="/courses" element={
            <PublicLayout>
              <Courses />
            </PublicLayout>
          } />
          
          <Route path="/faculty" element={
            <PublicLayout>
              <Faculty />
            </PublicLayout>
          } />
          
          <Route path="/events" element={
            <PublicLayout>
              <Events />
            </PublicLayout>
          } />
          
          <Route path="/gallery" element={
            <PublicLayout>
              <Gallery />
            </PublicLayout>
          } />
          
          <Route path="/contact" element={
            <PublicLayout>
              <Contact />
            </PublicLayout>
          } />
          
          {/* ========== REDIRECTS ========== */}
          <Route path="/admin" element={<Navigate to="/admin/dashboard" />} />
          
          {/* 404 Page - Keep at bottom */}
          <Route path="*" element={
            <PublicLayout>
              <div className="container py-5 text-center">
                <h1 className="display-1">404</h1>
                <h2 className="mb-4">Page Not Found</h2>
                <p className="lead">The page you are looking for doesn't exist.</p>
                <a href="/" className="btn btn-primary">Go Home</a>
              </div>
            </PublicLayout>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;